module.exports = __webpack_public_path__ + "static/media/Aalidhra9a2.f02bbf09.jpg";